module.exports = require('./helpers/bundle-url').getBundleURL('bxUMj') + "logo.7718c6df.svg";